<template>
  <div class="uifornoty">
    <span v-if="isLoadding" style="height: 100px">
      <v-container
        fill-height
        fluid
        :style="
          display === 'Desktop'
            ? 'height: ' + (heightDisplay - 325) + 'px;'
            : 'height: ' + (heightDisplay - 150) + 'px;'
        "
      >
        <v-row align="center" justify="center">
          <v-col
            lg="12"
            sm="12"
            md="12"
            cols="12"
            xl="12"
            xs="12"
            class="text-center"
            ><h1 style="font-size: 48px">
              <span style="color: #3f44a3">Kan</span>
              <span style="color: #4a98b2">Pramool</span>
            </h1>
          </v-col>
          <v-col
            class="text-center"
            sm="10"
            md="6"
            cols="8"
            xl="3"
            xs="10"
            lg="3"
            ><v-progress-linear
              color="#F8F364"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear
          ></v-col>
        </v-row>
      </v-container>
    </span>
    <v-container v-if="!isLoadding">
      <v-row
        ><v-col cols="12" sm="4" md="4" class="Format">
          <b>จังหวัด</b>
          <v-autocomplete
            v-model="provinceautocomplete"
            :items="provinceAll"
            item-text="name_th"
            item-value="id"
            outlined
            dense
            placeholder="จังหวัด"
          ></v-autocomplete>
        </v-col>

        <v-col lg="2" sm="2" md="2" class="Format"
          ><v-btn
            color="#144E8E"
            style="color: white"
            x-large
            block
            @click="checkgetprovinces()"
            >ค้นหาข้อมูล</v-btn
          ></v-col
        ><v-col lg="2" sm="2" md="2" class="Format"
          ><v-btn
            color="#FF8C00"
            style="color: white"
            x-large
            block
            @click="getall()"
            >เเสดงข้อมูลทั้งหมด</v-btn
          ></v-col
        ></v-row
      >
      <v-row>
        <v-col>
          <v-card>
            <v-card-subtitle style="color: white; background-color: #144e8e">
              <span style="font-size: 20px">ยืนยันการส่งลูกค้า</span>
            </v-card-subtitle>
            <v-card-text class="text--primary">
              <v-container>
                <v-row
                  justify="center"
                  align="center"
                  class="pl-3 pr-3 ml-3 mr-3"
                  :style="
                    index % 2 != 0
                      ? 'background-color: #F1F1F1;'
                      : 'background-color: #FFFFFF;'
                  "
                  v-for="(item, index) in torProject"
                  :key="index"
                >
                  <v-col>
                    <v-row
                      ><v-col
                        ><b style="font-size: 18px"
                          >เลขที่โครงการ {{ item.project_code }}</b
                        >
                      </v-col></v-row
                    >
                    <v-row
                      ><v-col
                        ><p style="color: #666666">
                          ชื่อโครงการ: {{ item.project_name }}
                        </p></v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        ><p style="color: #666666">
                          ประเภทประกาศ: {{ item.announcement_type }}
                        </p></v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col
                        ><p style="color: #666666">
                          จังหวัด: {{ item.name_th }}
                        </p></v-col
                      ></v-row
                    >
                    <v-row
                      ><v-col>
                        <v-icon class="mr-1" color="#144E8E"
                          >mdi-calendar-month</v-icon
                        >
                        <span style="color: #666666"
                          >สร้างเมื่อ : {{ item.created_datetime_th }}</span
                        ></v-col
                      ></v-row
                    >
                  </v-col>
                  <v-col lg="2" v-if="item.announcement_type != 'TOR'"
                    ><v-btn
                      color="#144E8E"
                      style="color: white"
                      x-large
                      block
                      @click="showdata(item)"
                      >ตรวจสอบข้อมูล</v-btn
                    ></v-col
                  >
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialogconferim" persistent max-width="60%">
      <v-card>
        <v-card-title style="color: white; background-color: #144e8e"
          ><p style="font-size: 35px">
            ยืนยันการส่งลูกค้า เลขที่โครงการ {{ form.project_code }}
          </p></v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-textarea
                  name="input-7-4"
                  label="ชื่อโครงการ(เรื่อง)"
                  v-model="form.project_name"
                  disabled
                  dense
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    dense
                    label="ชื่อหน่วยงาน"
                    type="text"
                    disabled
                    v-model="form.institution"
                  ></v-text-field>
                </v-col>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="form.province_th"
                      disabled
                      dense
                      label="จังหวัด"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="form.amphoe_th"
                      disabled
                      dense
                      label="อำเภอ"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="form.tambon_th"
                      disabled
                      dense
                      label="ตำบล"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" v-if="form.expenditure !== null">
                <v-text-field
                  @input="changeExpenditure()"
                  label="งบประมาณโครงการ"
                  dense
                  type="text"
                  disabled
                  v-model="form.expenditure_co"
                >
                  <span slot="append">บาท</span></v-text-field
                >
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  class="my-2"
                  label="ราคากลาง"
                  disabled
                  v-model="form.middle_price_co"
                  dense
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" v-if="form.same_price !== null">
                <v-text-field
                  dense
                  label="มูลค่าผลงานประเภทเดียวกัน"
                  type="text"
                  disabled
                  v-model="form.same_price_co"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.secret_price !== null">
                <v-text-field
                  dense
                  label="ราคาซอง"
                  type="text"
                  disabled
                  v-model="form.secret_price_co"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="form.genus_typ_id"
                  item-text="genus_typ_name"
                  item-value="genus_typ_id"
                  disabled
                  dense
                  label="ประเภทการจัดหา"
                  :items="torGenusTyp"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.type_of_work_id"
                  disabled
                  item-text="job_type_name"
                  item-value="job_type_id"
                  :items="typeOfWork"
                  hide-details="auto"
                  dense
                  chips
                  small-chips
                  label="ประเภทงาน"
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip close small class="chip--select-multi">
                      {{ data.item.job_type_name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content
                        v-text="data.item.job_type_name"
                      ></v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.tor_date_start !== null"
              >
                <v-text-field
                  dense
                  label="วันที่เริ่มประกาศ"
                  type="text"
                  disabled
                  v-model="form.tor_date_start"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="form.tor_date_end !== null">
                <v-text-field
                  dense
                  label="วันที่สิ้นสุดประกาศ"
                  type="text"
                  disabled
                  v-model="form.tor_date_end"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.induce_date_start !== null"
              >
                <v-text-field
                  dense
                  label="วันที่เริ่มเชิญชวน"
                  type="text"
                  disabled
                  v-model="form.induce_date_start"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.submission_date !== null"
              >
                <v-text-field
                  dense
                  label="วันที่ยื่นเสนอราคา"
                  type="text"
                  disabled
                  v-model="form.submission_date"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.special_features !== null"
              >
                <v-text-field
                  dense
                  label="คุณสมบัติพิเศษ"
                  type="text"
                  disabled
                  v-model="form.special_features"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.institution_tall !== null"
              >
                <v-text-field
                  dense
                  label="เบอร์โทรหน่วยงาน"
                  type="text"
                  disabled
                  v-model="form.institution_tall"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" v-if="form.latitude !== null">
                <v-text-field
                  dense
                  label="latitude"
                  type="text"
                  disabled
                  v-model="form.latitude"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="6" v-if="form.longitude !== null">
                <v-text-field
                  dense
                  label="longitude"
                  type="text"
                  disabled
                  v-model="form.longitude"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col style="width: 10px; height: 40px">
                <a style="" @click="changeDownloadLink()"
                  ><u>เปิดดูข้อมูลเพิ่มเติม</u></a
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="conferimproject()" style="color: #fff">
            <v-icon left light style="color: #fff"
              >mdi-content-save-outline</v-icon
            >
            ยืนยันการส่งลูกค้า
          </v-btn>
          <v-btn color="orange" @click="editdata()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-border-color</v-icon>
            แก้ไขข้อมูล
          </v-btn>
          <v-btn color="red" @click="cancelScreen()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
            ปิดหน้าจอ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent max-width="70%">
      <v-card>
        <v-card-title style="color: white; background-color: #144e8e"
          ><p style="font-size: 35px">
            แก้ไขข้อมูลโครงการ : {{ form.project_code }}
          </p></v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-textarea
                  required
                  label="ชื่อโครงการ(เรื่อง)"
                  v-model="form.project_name"
                  dense
                ></v-textarea>
              </v-col>
              <v-col>
                <v-row>
                  <v-col cols="12" sm="6" md="6" class="Format">
                    <v-text-field
                      label="ชื่อหน่วยงาน"
                      type="text"
                      dense
                      v-model="form.institution"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="form.province"
                      item-text="name_th"
                      item-value="id"
                      :items="provinceAll"
                      @change="getamphures()"
                      outlined
                      dense
                      label="จังหวัด"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="form.amphures"
                      @change="getdistricts()"
                      :items="amphoeAll"
                      item-text="name_th"
                      item-value="id"
                      outlined
                      dense
                      label="อำเภหอ"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                      v-model="form.tambon"
                      :items="tambonAll"
                      item-text="name_th"
                      item-value="id"
                      outlined
                      dense
                      label="ตำบล"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-text-field
                  label="งบประมาณโครงการ"
                  type="text"
                  dense
                  v-model="form.expenditure"
                  required
                >
                  <span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.middle_price !== null"
                style="padding-left: 0px"
              >
                <v-text-field
                  class="my-2"
                  label="ราคากลาง"
                  v-model="form.middle_price"
                  required
                  dense
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.same_price !== null"
              >
                <v-text-field
                  class="my-2"
                  label="มูลค่าผลงานประเภทเดียวกัน"
                  v-model="form.same_price"
                  required
                  dense
                  @input="changeSame()"
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.secret_price !== null"
              >
                <v-text-field
                  class="my-2"
                  dense
                  @input="changeSecret()"
                  label="ราคาซอง"
                  v-model="form.secret_price"
                  required
                  target="#dropdown-example-2"
                  ><span slot="append">บาท</span></v-text-field
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.genus_typ_id"
                  item-text="genus_typ_name"
                  item-value="genus_typ_id"
                  required
                  dense
                  label="ประเภทการจัดหา"
                  :items="torGenusTyp"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="Format">
                <v-autocomplete
                  v-model="form.type_of_work_id"
                  item-text="job_type_name"
                  item-value="job_type_id"
                  :items="typeOfWork"
                  hide-details="auto"
                  dense
                  chips
                  small-chips
                  label="ประเภทงาน"
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip close small class="chip--select-multi">
                      {{ data.item.job_type_name }}
                    </v-chip>
                  </template>

                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content
                        v-text="data.item.job_type_name"
                      ></v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-if="form.induce_date_start !== null"
                style="padding-left: 0px"
              >
                <v-card-text>
                  <v-menu
                    ref="menu"
                    v-model="menu_induce_date_start"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                  </v-menu>
                  <v-dialog
                    ref="dialog"
                    v-model="modal_induce_date_start"
                    persistent
                    width="320px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="วันที่เริ่มเชิญชวน"
                        readonly
                        placeholder="คลิกเพื่อเลือก"
                        v-model="form.induce_date_start"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        required
                        dense
                        target="#dropdown-example-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.induce_date_start"
                      scrollable
                      locale="th-TH"
                      color="green lighten-1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="success"
                        @click="
                          $refs.dialog.save(day_induce_date_start),
                            (modal_induce_date_start = false)
                        "
                      >
                        ตกลง
                      </v-btn>
                      <v-btn
                        text
                        color="red"
                        @click="modal_induce_date_start = false"
                        >ยกเลิก</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.submission_date !== null"
              >
                <v-card-text class="Format">
                  <v-menu
                    ref="menu"
                    v-model="menu_submission_date"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                  </v-menu>
                  <v-dialog
                    ref="dialog"
                    v-model="modal_submission_date"
                    persistent
                    width="320px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="วันที่ยื่นเสนอราคา"
                        readonly
                        placeholder="คลิกเพื่อเลือก"
                        v-model="form.submission_date"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        required
                        dense
                        target="#dropdown-example-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.submission_date"
                      scrollable
                      locale="th-TH"
                      color="green lighten-1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="success"
                        @click="
                          $refs.dialog.save(day_submission_date),
                            (modal_submission_date = false)
                        "
                      >
                        ตกลง
                      </v-btn>
                      <v-btn
                        text
                        color="red"
                        @click="modal_submission_date = false"
                        >ยกเลิก</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.tor_date_start !== null"
                style="padding-left: 0px"
              >
                <v-card-text class="Format">
                  <v-menu
                    ref="menu"
                    v-model="menu_tor_date_start"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                  </v-menu>
                  <v-dialog
                    ref="dialog"
                    v-model="modal_tor_date_start"
                    persistent
                    width="320px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="วันที่เริ่มประกาศTOR"
                        readonly
                        placeholder="คลิกเพื่อเลือก"
                        v-model="form.tor_date_start"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        required
                        dense
                        target="#dropdown-example-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.tor_date_start"
                      scrollable
                      locale="th-TH"
                      color="green lighten-1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="success"
                        @click="
                          $refs.dialog.save(day_tor_date_start),
                            (modal_tor_date_start = false)
                        "
                      >
                        ตกลง
                      </v-btn>
                      <v-btn
                        text
                        color="red"
                        @click="modal_tor_date_start = false"
                        >ยกเลิก</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.tor_date_end !== null"
                style="padding-left: 0px"
              >
                <v-card-text class="Format">
                  <v-menu
                    ref="menu"
                    v-model="menu_tor_date_end"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                  </v-menu>
                  <v-dialog
                    ref="dialog"
                    v-model="modal_tor_date_end"
                    persistent
                    width="320px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="วันที่สื้นสุดประกาศ TOR"
                        readonly
                        placeholder="คลิกเพื่อเลือก"
                        v-model="form.tor_date_end"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        required
                        dense
                        target="#dropdown-example-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="form.tor_date_end"
                      scrollable
                      locale="th-TH"
                      color="green lighten-1"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="success"
                        @click="
                          $refs.dialog.save(day_tor_date_end),
                            (modal_tor_date_end = false)
                        "
                      >
                        ตกลง
                      </v-btn>
                      <v-btn
                        text
                        color="red"
                        @click="modal_tor_date_end = false"
                        >ยกเลิก</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.special_features !== null"
              >
                <v-text-field
                  class="my-2"
                  dense
                  label="คุณสมบัติพิเศษ"
                  v-model="form.special_features"
                  required
                  target="#dropdown-example-2"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.institution_tall !== null"
              >
                <v-text-field
                  label="เบอร์โทรหน่วยงาน"
                  dense
                  @input="changeTel()"
                  type="text"
                  v-model="form.institution_tall"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.latitude !== null"
              >
                <v-text-field
                  label="ตำเเหน่งหน้างานlatitude"
                  type="text"
                  dense
                  v-model="form.latitude"
                  required
                  v-if="form.latitude !== null"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                class="Format"
                v-if="form.longitude !== null"
              >
                <v-text-field
                  class="my-2"
                  label="ตำเเหน่งหน้างานlongitude"
                  v-model="form.longitude"
                  required
                  dense
                  target="#dropdown-example-2"
                  v-if="form.longitude !== null"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="update()" style="color: #fff">
            <v-icon left light style="color: #fff"
              >mdi-content-save-outline</v-icon
            >
            บันทึกเเละยืนยันการส่งลูกค้า
          </v-btn>

          <v-btn color="red" @click="cancelScreenedit()" style="color: #fff">
            <v-icon left light style="color: #fff">mdi-close-octagon</v-icon>
            ปิดหน้าจอ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      provinceautocomplete: null,
      provinceAll: [],
      amphoeAll: [],
      tambonAll: [],
      day_induce_date_start: null,
      day_submission_date: null,
      day_tor_date_start: null,
      day_tor_date_end: null,
      menu_induce_date_start: null,
      modal_induce_date_start: null,
      menu_submission_date: null,
      modal_submission_date: null,
      menu_tor_date_start: null,
      modal_tor_date_start: null,
      menu_tor_date_end: null,
      modal_tor_date_end: null,
      typeOfWork: [],
      input_file: null,
      dialogconferim: false,
      dialogEdit: false,
      search: "",
      display: false,
      heightDisplay: null,
      torGenusTyp: [],
      isLoadding: false,
      form: {
        point_admin: null,
        point_staff: null,
        type: "tor",
        genustyp: null,
        institution: null, //ชื่อหน่วยงานรับผิดชอบ
        project_code: null, //รหัสโครงการ
        project_name: null, //ชื่อโครงการ
        genus_typ_id: null,
        tor_date_start: null, //วันที่เริ่มประกาศ
        tor_date_end: null, //วันที่สิ้นสุดประกาศ
        tor_date_project: null, //วันที่ประกาศ-วันที่สิ้นสุดรับฟังคำวิจารณ์
        expenditure: "", //งบประมาณโครงการ_co
        expenditure_co: "",
        latitude: null,
        longitude: null,
        province: null, //จังหวัด
        province_th: null,
        amphoe: null,
        amphoe_th: null,
        tambon: null,
        tambon_th: null,
        genus_typ: null, //ประเภทการจัดหา
        type_of_work_id: null, //ประเภทงาน
        induce_date_start: "", //วันที่เริ่มเชิญชวน
        secret_price: "", //ราคาซอง
        secret_price_co: "",
        institution_tall: "", //เบอร์หน่วยงาน
        same_price: "", //มูลค่าผลงานประเภทเดียวกัน
        same_price_co: "",
        special_features: "", //คุณสมบัติพิเศษ
        submission_date: "", //วันที่ยื่นเสนอราคา
        middle_price: null, //ราคากลาง
        middle_price_co: null,
        download_link: "",
        created_by: localStorage.getItem("username"), //เพิ่มโดย
        created_by_notify: localStorage.getItem("fullname"),
        confirm_admin: null,
        confirm_by: localStorage.getItem("username"),
      },
      headers: [
        { text: "ประเภทประกาศ", value: "announcement_type" },
        { text: "รหัสโครงการ", value: "project_code" },
        { text: "ชื่อโครงการ", value: "project_name" },
        {
          text: "หน่วยงาน",
          align: "start",
          sortable: false,
          value: "institution",
        },
        { text: "งบประมาณ", value: "expenditure" },
        { text: "จังหวัด", value: "name_th" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      torProject: [],
    };
  },
  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/");
      } else {
        this.checkHightDisplay();
        this.isLoadding = true;
        axios.get(this.api + "/all/province").then((res) => {
          this.provinceAll = [];
          this.provinceAll = res.data.response;
          axios.get(this.api + "/all/amphures").then((res) => {
            this.amphoeAll = [];
            this.amphoeAll = res.data.response;
            axios.get(this.api + "/all/districts").then((res) => {
              this.tambonAll = [];
              this.tambonAll = res.data.response;
              axios.get(this.api + "/get/tor_genus_typ").then((res) => {
                this.torGenusTyp = [];
                this.torGenusTyp = res.data.response;
                axios.get(this.api + "/get/ebiiding_jobtype").then((res) => {
                  this.typeOfWork = [];
                  this.typeOfWork = res.data.response;
                  this.checkgetprovinces();
                });
              });
            });
          });
        });
      }
    }
  },
  methods: {
    checkHightDisplay() {
      this.heightDisplay = screen.height;
    },
    getall() {
      this.isLoadding = true;
      this.provinceautocomplete = "";
      axios.get(this.api + "/conferimall").then((res) => {
        this.isLoadding = false;
        this.torProject = [];
        this.torProject = res.data.response;
      });
    },
    checkgetprovinces() {
      if (this.provinceautocomplete !== null) {
        localStorage.setItem("province_confirm", this.provinceautocomplete);
      }
      if (
        localStorage.getItem("province_confirm") !== null &&
        !isNaN(localStorage.getItem("province_confirm"))
      ) {
        this.provinceautocomplete = parseInt(
          localStorage.getItem("province_confirm")
        );
        axios
          .post(this.api + "/post/conferim_provinces", {
            provinces_id: localStorage.getItem("province_confirm"),
          })
          .then((res) => {
            this.isLoadding = false;
            this.torProject = res.data.response;
          });
      } else {
        axios.get(this.api + "/conferimall").then((res) => {
          this.isLoadding = false;
          this.torProject = [];
          this.torProject = res.data.response;
        });
      }
    },
    changeDownloadLink() {
      window.open("" + this.form.download_link, "");
    },
    showdata(item) {
      this.form.download_link = item.download_link;
      this.dialogconferim = true;
      this.form.project_code = item.project_code;
      this.form.institution = item.institution;
      this.form.project_name = item.project_name;
      this.form.tor_date_start = item.tor_date_start_th;
      this.form.tor_date_end = item.tor_date_end_th;
      this.form.expenditure = item.expenditure;
      this.form.latitude = item.latitude;
      this.form.longitude = item.longitude;
      this.form.expenditure_co = item.expenditure
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.form.province = item.province;
      this.form.amphures = parseInt(item.amphoe);
      this.form.tambon = item.tambon;
      this.form.province_th = item.name_th;
      this.form.amphoe_th = item.amphures;
      this.form.tambon_th = item.districts;
      this.form.genus_typ_id = parseInt(item.genus_typ_id);

      this.form.type_of_work_id = item.type_of_work_id
        .replace(/'/g, "")
        .split(",");
      this.form.middle_price = item.middle_price;
      this.form.middle_price_co = item.middle_price
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      this.announcement_type = item.announcement_type;
      this.form.induce_date_start = item.induce_date_start_th;
      this.form.submission_date = item.submission_date_th;
      this.form.same_price = item.same_price;
      if (item.same_price != null) {
        this.form.same_price_co = item.same_price
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.form.same_price_co = null;
      }
      if (item.secret_price != null) {
        this.form.secret_price_co = item.secret_price
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        this.form.secret_price = null;
      }

      this.form.special_features = item.special_features;
      this.form.secret_price = item.secret_price;

      this.form.institution_tall = item.institution_tall;
    },
    cancelScreenedit() {
      this.dialogEdit = false;
    },
    conferimproject() {
      //001
      this.isLoadding = true;
      this.dialogconferim = false;
      this.form.confirm_admin = 1;
      this.form.point_admin = 1;
      this.form.point_staff = 1;
      axios.post(this.api + "/update/confirm_admin", this.form).then((res) => {
        this.isLoadding = false;
        if (res.data.status) {
          location.reload();
        } else {
          alert("บันทึกข้อมูลไม่เรียบร้อย");
        }
      });
      this.dialog = false;
    },
    getamphures() {
      if (this.form.province != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/amphures", { province: this.form.province })
          .then((res) => {
            this.isLoadding = false;
            this.amphuress = res.data.response;
            console.log(this.amphuress);
          });
      } else {
        alert("กรุณาเลือกจังหวัด");
      }
    },
    getdistricts() {
      if (this.form.amphures != null) {
        this.isLoadding = true;
        axios
          .post(this.api + "/get/districts", { amphure: this.form.amphures })
          .then((res) => {
            this.isLoadding = false;
            this.districtss = res.data.response;
          });
      } else {
        alert("กรุณาเลือกอำเภอ");
      }
    },
    update() {
      //002
      this.isLoadding = true;
      this.form.point_admin = 1;
      this.form.point_staff = -1;
      if (this.announcement_type === "tor") {
        axios.post(this.api + "/update/conferim/tor", this.form).then((res) => {
          this.isLoadding = false;
          if (res.data.status) {
            location.reload();
          }
        });
      } else {
        this.isLoadding = true;
        axios
          .post(this.api + "/update/conferim/invite", this.form)
          .then((res) => {
            this.isLoadding = false;
            if (res.data.status) {
              location.reload();
            }
          });
      }

      this.dialogEdit = false;

      location.reload();
    },
    editdata() {
      if (this.announcement_type === "invite") {
        this.form.induce_date_start =
          this.form.induce_date_start.split("-")[2] -
          543 +
          "-" +
          this.form.induce_date_start
            .split("-")[1]
            .replace(/ม.ค./g, "1")
            .replace(/ก.พ./g, "2")
            .replace(/มี.ค./g, "3")
            .replace(/เม.ย./g, "4")
            .replace(/พ.ค./g, "5")
            .replace(/มิ.ย./g, "6")
            .replace(/ก.ค./g, "7")
            .replace(/ส.ค./g, "8")
            .replace(/ก.ย./g, "9")
            .replace(/ต.ค./g, "10")
            .replace(/พ.ย./g, "11")
            .replace(/ธ.ค./g, "12") +
          "-" +
          this.form.induce_date_start.split("-")[0];
        this.form.submission_date =
          this.form.submission_date.split("-")[2] -
          543 +
          "-" +
          this.form.submission_date
            .split("-")[1]
            .replace(/ม.ค./g, "1")
            .replace(/ก.พ./g, "2")
            .replace(/มี.ค./g, "3")
            .replace(/เม.ย./g, "4")
            .replace(/พ.ค./g, "5")
            .replace(/มิ.ย./g, "6")
            .replace(/ก.ค./g, "7")
            .replace(/ส.ค./g, "8")
            .replace(/ก.ย./g, "9")
            .replace(/ต.ค./g, "10")
            .replace(/พ.ย./g, "11")
            .replace(/ธ.ค./g, "12") +
          "-" +
          this.form.submission_date.split("-")[0];
      } else {
        this.form.tor_date_start =
          this.form.tor_date_start.split("-")[2] -
          543 +
          "-" +
          this.form.tor_date_start
            .split("-")[1]
            .replace(/ม.ค./g, "1")
            .replace(/ก.พ./g, "2")
            .replace(/มี.ค./g, "3")
            .replace(/เม.ย./g, "4")
            .replace(/พ.ค./g, "5")
            .replace(/มิ.ย./g, "6")
            .replace(/ก.ค./g, "7")
            .replace(/ส.ค./g, "8")
            .replace(/ก.ย./g, "9")
            .replace(/ต.ค./g, "10")
            .replace(/พ.ย./g, "11")
            .replace(/ธ.ค./g, "12") +
          "-" +
          this.form.tor_date_start.split("-")[0];
        this.form.tor_date_end =
          this.form.tor_date_end.split("-")[2] -
          543 +
          "-" +
          this.form.tor_date_end
            .split("-")[1]
            .replace(/ม.ค./g, "1")
            .replace(/ก.พ./g, "2")
            .replace(/มี.ค./g, "3")
            .replace(/เม.ย./g, "4")
            .replace(/พ.ค./g, "5")
            .replace(/มิ.ย./g, "6")
            .replace(/ก.ค./g, "7")
            .replace(/ส.ค./g, "8")
            .replace(/ก.ย./g, "9")
            .replace(/ต.ค./g, "10")
            .replace(/พ.ย./g, "11")
            .replace(/ธ.ค./g, "12") +
          "-" +
          this.form.tor_date_end.split("-")[0];
      }
      this.dialogconferim = false;
      this.dialogEdit = true;
    },
    cancelScreen() {
      this.dialogconferim = false;
    },
  },
};
</script>
<style></style>
